import { Swiper } from 'swiper';
import 'swiper/css';

export default function () {
    if (document.querySelector('.latest-job__swiper')) {
        initSwiper();
    }
}

const initSwiper = () => {
    const swiper = new Swiper('.latest-job__swiper', {
        slidesPerView: 1.2,
        spaceBetween: 20,
        grabCursor: true,
        breakpoints: {
            768: {
                slidesPerView: 2.2,
                spaceBetween: 16,
            },
            1024: {
                grabCursor: false,
                enabled: false,
                slidesPerView: 3,
                spaceBetween: 16,
            },
        },
    });
};
